import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { PageHeader } from '../../components/PageHeader';
import Items from './Items';
import Totals from './Totals';
import Modality from './Modality';
import Scheduling from './Scheduling';
import Address from './Address';
import Payment from './Payment';
import Client from './Client';
import Send from './Send';
import { Checkout } from './Checkout';

import { orderClose } from '../../store/modules/order/actions';

import useStyles from './styles';

export default function Order() {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const dispatch = useDispatch();

  const { modalOrder } = useSelector(state => state.order);

  const handleClose = () => {
    dispatch(orderClose());
  };

  return (
    <Dialog fullScreen={fullScreen} open={modalOrder} className={classes.root}>
      <PageHeader handleClose={handleClose} title="Pedido" />
      <div className={classes.content}>
        <Items />
        <Totals />
        <Modality />
        <Scheduling />
        <Address />
        <Payment />
        <Client />
        <Send />
        <Checkout />
      </div>
    </Dialog>
  );
}
